import { atom } from 'recoil';

export const isDropoffsFilterModalOpenAtom = atom<boolean>({
  key: 'isDropoffsFilterModalOpenState',
  default: false,
});
